export const cotationChange = {
  Liste: {
    table: {
      title: 'Liste des contrats',
      culumn: {
        state: 'Etat',
        market_room: 'Salle de marché',
        company: 'Société',
        company_intermediaire: 'Société intermediaire',
        date_start: 'Date début',
        date_end: 'Date fin',
        date_edit: 'Date de modification',
      },
    },
    fiche: {
      title: "Création d'un contrat",
      edit_title: 'Fiche du contrat {{code}}',
      champs: {
        name: 'Name',
        market_room: 'Salle de marché',
        code: 'Code',
      },
    },
  },
}

